// package: quest
// file: quest/model.proto

import * as activity_cardgame_model from "../activity/cardgame/model";
import * as common_asset_type from "../common/asset_type";
import * as common_enum_value_options from "../common/enum_value_options";
import * as common_source_type from "../common/source_type";
import * as order_model from "../order/model";
import * as order_base_model from "../order/base/model";
import * as trade_transaction from "../trade/transaction";
import * as user_base_model from "../user/base/model";

export const MembershipOrderBonus = {
    encode(object) {
        const message = {};
        if (object.taskID != null) {
            if (object.taskID !== "") {
                message.taskID = String(object.taskID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.orderID != null) {
            if (object.orderID !== "") {
                message.orderID = String(object.orderID);
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = object.amount | 0;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = object.createdTime | 0;
            }
        }
        if (object.activeTime != null) {
            if (object.activeTime !== 0) {
                message.activeTime = object.activeTime | 0;
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            taskID: "",
            userID: "",
            orderID: "",
            taskType: 0,
            amount: 0,
            createdTime: 0,
            activeTime: 0,
            taskStatus: 0,
            desc: "",
        };

        if (message.taskID != null) {
            object.taskID = message.taskID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.orderID != null) {
            object.orderID = message.orderID;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.amount != null) {
            object.amount = message.amount;
        }
        if (message.createdTime != null) {
            object.createdTime = message.createdTime;
        }
        if (message.activeTime != null) {
            object.activeTime = message.activeTime;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        return object;
    },
};

export const MembershipOrderBonusMonthlySummaryInfo = {
    encode(object) {
        const message = {};
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.yearMonth != null) {
            if (object.yearMonth !== "") {
                message.yearMonth = String(object.yearMonth);
            }
        }
        if (object.orderCount != null) {
            if (object.orderCount !== 0) {
                message.orderCount = object.orderCount | 0;
            }
        }
        if (object.totalAmount != null) {
            if (object.totalAmount !== 0) {
                message.totalAmount = object.totalAmount | 0;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userID: "",
            yearMonth: "",
            orderCount: 0,
            totalAmount: 0,
            taskType: 0,
            status: 0,
        };

        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.yearMonth != null) {
            object.yearMonth = message.yearMonth;
        }
        if (message.orderCount != null) {
            object.orderCount = message.orderCount;
        }
        if (message.totalAmount != null) {
            object.totalAmount = message.totalAmount;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        return object;
    },
};

MembershipOrderBonusMonthlySummaryInfo.Status = {
    STATUS_UNDEFINED: 0,
    STATUS_REWARD_CREATED: 1,
    STATUS_REWARD_GIVEN: 2,
};


export const MembershipOrderBonusCompletedSummaryInfo = {
    encode(object) {
        const message = {};
        if (object.orderCount != null) {
            if (object.orderCount !== 0) {
                message.orderCount = object.orderCount | 0;
            }
        }
        if (object.totalAmount != null) {
            if (object.totalAmount !== 0) {
                message.totalAmount = object.totalAmount | 0;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            orderCount: 0,
            totalAmount: 0,
            taskType: 0,
        };

        if (message.orderCount != null) {
            object.orderCount = message.orderCount;
        }
        if (message.totalAmount != null) {
            object.totalAmount = message.totalAmount;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        return object;
    },
};

export const BriefOrder = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.itemID != null) {
            if (object.itemID !== "") {
                message.itemID = String(object.itemID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        if (object.itemTitle != null) {
            if (object.itemTitle !== "") {
                message.itemTitle = String(object.itemTitle);
            }
        }
        if (object.createTime != null) {
            if (object.createTime !== 0) {
                message.createTime = object.createTime | 0;
            }
        }
        if (object.sourceType != null) {
            if (object.sourceType !== 0) {
                message.sourceType = object.sourceType;
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            itemID: "",
            userID: "",
            imageURL: "",
            itemTitle: "",
            createTime: 0,
            sourceType: 0,
            status: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.itemID != null) {
            object.itemID = message.itemID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        if (message.itemTitle != null) {
            object.itemTitle = message.itemTitle;
        }
        if (message.createTime != null) {
            object.createTime = message.createTime;
        }
        if (message.sourceType != null) {
            object.sourceType = message.sourceType;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        return object;
    },
};

export const MembershipOrderBonusWithBriefOrder = {
    encode(object) {
        const message = {};
        if (object.membershipOrderBonus != null) {
            message.membershipOrderBonus = MembershipOrderBonus.encode(object.membershipOrderBonus);
        }
        if (object.briefOrder != null) {
            message.briefOrder = BriefOrder.encode(object.briefOrder);
        }
        return message;
    },

    decode(message) {
        const object = {
            membershipOrderBonus: null,
            briefOrder: null,
        };

        if (message.membershipOrderBonus != null) {
            object.membershipOrderBonus = MembershipOrderBonus.decode(message.membershipOrderBonus);
        }
        if (message.briefOrder != null) {
            object.briefOrder = BriefOrder.decode(message.briefOrder);
        }
        return object;
    },
};

export const TaskDetail = {
    encode(object) {
        const message = {};
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = object.amount | 0;
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = object.createdTime | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            taskType: 0,
            amount: 0,
            status: 0,
            createdTime: 0,
        };

        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.amount != null) {
            object.amount = message.amount;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.createdTime != null) {
            object.createdTime = message.createdTime;
        }
        return object;
    },
};

export const EnlargeFlowTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.taskTitle != null) {
            if (object.taskTitle !== "") {
                message.taskTitle = String(object.taskTitle);
            }
        }
        if (object.description != null) {
            if (object.description !== "") {
                message.description = String(object.description);
            }
        }
        if (object.iconURL != null) {
            if (object.iconURL !== "") {
                message.iconURL = String(object.iconURL);
            }
        }
        if (object.bubbleTitle != null) {
            if (object.bubbleTitle !== "") {
                message.bubbleTitle = String(object.bubbleTitle);
            }
        }
        if (object.transactionTitle != null) {
            if (object.transactionTitle !== "") {
                message.transactionTitle = String(object.transactionTitle);
            }
        }
        if (object.assetAmount != null) {
            if (object.assetAmount !== 0) {
                message.assetAmount = object.assetAmount | 0;
            }
        }
        if (object.linkURL != null) {
            if (object.linkURL !== "") {
                message.linkURL = String(object.linkURL);
            }
        }
        if (object.sourceType != null) {
            if (object.sourceType !== 0) {
                message.sourceType = object.sourceType;
            }
        }
        if (object.order != null) {
            if (object.order !== 0) {
                message.order = object.order | 0;
            }
        }
        if (object.enlargeFlowTaskStatus != null) {
            if (object.enlargeFlowTaskStatus !== 0) {
                message.enlargeFlowTaskStatus = object.enlargeFlowTaskStatus;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = object.createdTime | 0;
            }
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = object.updatedTime | 0;
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = object.startTime | 0;
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = object.endTime | 0;
            }
        }
        if (object.taskCategory != null) {
            if (object.taskCategory !== 0) {
                message.taskCategory = object.taskCategory;
            }
        }
        if (object.ext != null) {
            if (object.ext !== "") {
                message.ext = String(object.ext);
            }
        }
        if (object.enableABTest != null) {
            if (object.enableABTest !== false) {
                message.enableABTest = Boolean(object.enableABTest);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskType: 0,
            taskTitle: "",
            description: "",
            iconURL: "",
            bubbleTitle: "",
            transactionTitle: "",
            assetAmount: 0,
            linkURL: "",
            sourceType: 0,
            order: 0,
            enlargeFlowTaskStatus: 0,
            createdTime: 0,
            updatedTime: 0,
            startTime: 0,
            endTime: 0,
            taskCategory: 0,
            ext: "",
            enableABTest: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.taskTitle != null) {
            object.taskTitle = message.taskTitle;
        }
        if (message.description != null) {
            object.description = message.description;
        }
        if (message.iconURL != null) {
            object.iconURL = message.iconURL;
        }
        if (message.bubbleTitle != null) {
            object.bubbleTitle = message.bubbleTitle;
        }
        if (message.transactionTitle != null) {
            object.transactionTitle = message.transactionTitle;
        }
        if (message.assetAmount != null) {
            object.assetAmount = message.assetAmount;
        }
        if (message.linkURL != null) {
            object.linkURL = message.linkURL;
        }
        if (message.sourceType != null) {
            object.sourceType = message.sourceType;
        }
        if (message.order != null) {
            object.order = message.order;
        }
        if (message.enlargeFlowTaskStatus != null) {
            object.enlargeFlowTaskStatus = message.enlargeFlowTaskStatus;
        }
        if (message.createdTime != null) {
            object.createdTime = message.createdTime;
        }
        if (message.updatedTime != null) {
            object.updatedTime = message.updatedTime;
        }
        if (message.startTime != null) {
            object.startTime = message.startTime;
        }
        if (message.endTime != null) {
            object.endTime = message.endTime;
        }
        if (message.taskCategory != null) {
            object.taskCategory = message.taskCategory;
        }
        if (message.ext != null) {
            object.ext = message.ext;
        }
        if (message.enableABTest != null) {
            object.enableABTest = message.enableABTest;
        }
        return object;
    },
};

export const Monthly1YuanBuyItem = {
    encode(object) {
        const message = {};
        if (object.min != null) {
            if (object.min !== 0) {
                message.min = object.min | 0;
            }
        }
        if (object.max != null) {
            if (object.max !== 0) {
                message.max = object.max | 0;
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = object.amount | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            min: 0,
            max: 0,
            amount: 0,
        };

        if (message.min != null) {
            object.min = message.min;
        }
        if (message.max != null) {
            object.max = message.max;
        }
        if (message.amount != null) {
            object.amount = message.amount;
        }
        return object;
    },
};

export const MembershipFamilyBonusInfo = {
    encode(object) {
        const message = {};
        if (object.userInfo != null) {
            message.userInfo = user_base_model.UserInfoPublicV2.encode(object.userInfo);
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = object.amount | 0;
            }
        }
        if (object.orderTime != null) {
            if (object.orderTime !== 0) {
                message.orderTime = object.orderTime | 0;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userInfo: null,
            desc: "",
            amount: 0,
            orderTime: 0,
            taskType: 0,
            taskStatus: 0,
        };

        if (message.userInfo != null) {
            object.userInfo = user_base_model.UserInfoPublicV2.decode(message.userInfo);
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        if (message.amount != null) {
            object.amount = message.amount;
        }
        if (message.orderTime != null) {
            object.orderTime = message.orderTime;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        return object;
    },
};

export const MembershipFamilyTaskInfo = {
    encode(object) {
        const message = {};
        if (object.familyUserID != null) {
            if (object.familyUserID !== "") {
                message.familyUserID = String(object.familyUserID);
            }
        }
        if (object.membershipFamilyBonusInfos != null) {
            if (!Array.isArray(object.membershipFamilyBonusInfos)) {
                throw TypeError("membershipFamilyBonusInfos: array expected");
            }
            if (object.membershipFamilyBonusInfos.length > 0) {
                message.membershipFamilyBonusInfos = [];
                for (let i = 0; i < object.membershipFamilyBonusInfos.length; ++i) {
                    message.membershipFamilyBonusInfos[i] = MembershipFamilyBonusInfo.encode(object.membershipFamilyBonusInfos[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            familyUserID: "",
            membershipFamilyBonusInfos: [],
        };

        if (message.familyUserID != null) {
            object.familyUserID = message.familyUserID;
        }
        if (message.membershipFamilyBonusInfos != null) {
            object.membershipFamilyBonusInfos = [];
            for (let i = 0; i < message.membershipFamilyBonusInfos.length; ++i) {
                object.membershipFamilyBonusInfos[i] = MembershipFamilyBonusInfo.decode(message.membershipFamilyBonusInfos[i]);
            }
        }
        return object;
    },
};

export const FamilyGroupBonusInfo = {
    encode(object) {
        const message = {};
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        if (object.orderTime != null) {
            if (object.orderTime !== 0) {
                message.orderTime = String(object.orderTime);
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.magnification != null) {
            if (object.magnification !== 0) {
                message.magnification = String(object.magnification);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            desc: "",
            amount: 0,
            orderTime: 0,
            taskType: 0,
            taskStatus: 0,
            magnification: 0,
        };

        if (message.desc != null) {
            object.desc = message.desc;
        }
        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        if (message.orderTime != null) {
            object.orderTime = parseInt(message.orderTime, 10);
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.magnification != null) {
            object.magnification = parseInt(message.magnification, 10);
        }
        return object;
    },
};

export const ExchangeBonusInfo = {
    encode(object) {
        const message = {};
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        if (object.orderTime != null) {
            if (object.orderTime !== 0) {
                message.orderTime = String(object.orderTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            desc: "",
            amount: 0,
            orderTime: 0,
        };

        if (message.desc != null) {
            object.desc = message.desc;
        }
        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        if (message.orderTime != null) {
            object.orderTime = parseInt(message.orderTime, 10);
        }
        return object;
    },
};

export const TaskDetailV2 = {
    encode(object) {
        const message = {};
        let ext_ = false;
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.code != null) {
            if (object.code !== "") {
                message.code = String(object.code);
            }
        }
        if (object.description != null) {
            if (object.description !== "") {
                message.description = String(object.description);
            }
        }
        if (object.unclaimed != null) {
            if (!Array.isArray(object.unclaimed)) {
                throw TypeError("unclaimed: array expected");
            }
            if (object.unclaimed.length > 0) {
                message.unclaimed = [];
                for (let i = 0; i < object.unclaimed.length; ++i) {
                    message.unclaimed[i] = Asset.encode(object.unclaimed[i]);
                }
            }
        }
        if (object.briefOrder != null) {
            message.briefOrder = BriefOrder.encode(object.briefOrder);
        }
        if (object.price4EachCompletion != null) {
            if (!Array.isArray(object.price4EachCompletion)) {
                throw TypeError("price4EachCompletion: array expected");
            }
            if (object.price4EachCompletion.length > 0) {
                message.price4EachCompletion = [];
                for (let i = 0; i < object.price4EachCompletion.length; ++i) {
                    message.price4EachCompletion[i] = Asset.encode(object.price4EachCompletion[i]);
                }
            }
        }
        if (object.tags != null) {
            if (!Array.isArray(object.tags)) {
                throw TypeError("tags: array expected");
            }
            if (object.tags.length > 0) {
                message.tags = [];
                for (let i = 0; i < object.tags.length; ++i) {
                    message.tags[i] = object.tags[i];
                }
            }
        }
        if (object.iconType != null) {
            if (object.iconType !== 0) {
                message.iconType = object.iconType;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = String(object.createdTime);
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = String(object.expiredTime);
            }
        }
        if (object.gameCard != null && !ext_) {
            message.gameCard = GameCard.encode(object.gameCard);
            ext_ = true;
        }
        if (object.taskMultiple != null && !ext_) {
            message.taskMultiple = TaskMultiple.encode(object.taskMultiple);
            ext_ = true;
        }
        if (object.signInContinueDayList != null && !ext_) {
            message.signInContinueDayList = SignInContinueDayList.encode(object.signInContinueDayList);
            ext_ = true;
        }
        if (object.taskFreshVideo != null && !ext_) {
            message.taskFreshVideo = TaskFreshVideo.encode(object.taskFreshVideo);
            ext_ = true;
        }
        if (object.taskPraise != null && !ext_) {
            message.taskPraise = TaskPraise.encode(object.taskPraise);
            ext_ = true;
        }
        if (object.taskVideoBuy != null && !ext_) {
            message.taskVideoBuy = TaskVideoBuy.encode(object.taskVideoBuy);
            ext_ = true;
        }
        if (object.pullNew != null && !ext_) {
            message.pullNew = PullNewExtension.encode(object.pullNew);
            ext_ = true;
        }
        if (object.xianwanGameExtra != null && !ext_) {
            message.xianwanGameExtra = XianwanGameExtra.encode(object.xianwanGameExtra);
            ext_ = true;
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userID: "",
            status: 0,
            taskType: 0,
            code: "",
            description: "",
            unclaimed: [],
            briefOrder: null,
            price4EachCompletion: [],
            tags: [],
            iconType: 0,
            createdTime: 0,
            expiredTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.code != null) {
            object.code = message.code;
        }
        if (message.description != null) {
            object.description = message.description;
        }
        if (message.unclaimed != null) {
            object.unclaimed = [];
            for (let i = 0; i < message.unclaimed.length; ++i) {
                object.unclaimed[i] = Asset.decode(message.unclaimed[i]);
            }
        }
        if (message.briefOrder != null) {
            object.briefOrder = BriefOrder.decode(message.briefOrder);
        }
        if (message.price4EachCompletion != null) {
            object.price4EachCompletion = [];
            for (let i = 0; i < message.price4EachCompletion.length; ++i) {
                object.price4EachCompletion[i] = Asset.decode(message.price4EachCompletion[i]);
            }
        }
        if (message.tags != null) {
            object.tags = [];
            for (let i = 0; i < message.tags.length; ++i) {
                    object.tags[i] = message.tags[i];
            }
        }
        if (message.iconType != null) {
            object.iconType = message.iconType;
        }
        if (message.createdTime != null) {
            object.createdTime = parseInt(message.createdTime, 10);
        }
        if (message.expiredTime != null) {
            object.expiredTime = parseInt(message.expiredTime, 10);
        }
        if (message.gameCard != null) {
            object.gameCard = GameCard.decode(message.gameCard);
                object.ext = "gameCard";
        }
        if (message.taskMultiple != null) {
            object.taskMultiple = TaskMultiple.decode(message.taskMultiple);
                object.ext = "taskMultiple";
        }
        if (message.signInContinueDayList != null) {
            object.signInContinueDayList = SignInContinueDayList.decode(message.signInContinueDayList);
                object.ext = "signInContinueDayList";
        }
        if (message.taskFreshVideo != null) {
            object.taskFreshVideo = TaskFreshVideo.decode(message.taskFreshVideo);
                object.ext = "taskFreshVideo";
        }
        if (message.taskPraise != null) {
            object.taskPraise = TaskPraise.decode(message.taskPraise);
                object.ext = "taskPraise";
        }
        if (message.taskVideoBuy != null) {
            object.taskVideoBuy = TaskVideoBuy.decode(message.taskVideoBuy);
                object.ext = "taskVideoBuy";
        }
        if (message.pullNew != null) {
            object.pullNew = PullNewExtension.decode(message.pullNew);
                object.ext = "pullNew";
        }
        if (message.xianwanGameExtra != null) {
            object.xianwanGameExtra = XianwanGameExtra.decode(message.xianwanGameExtra);
                object.ext = "xianwanGameExtra";
        }
        return object;
    },
};

export const Asset = {
    encode(object) {
        const message = {};
        if (object.assetType != null) {
            if (object.assetType !== 0) {
                message.assetType = object.assetType;
            }
        }
        if (object.assetAmount != null) {
            if (object.assetAmount !== 0) {
                message.assetAmount = String(object.assetAmount);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            assetType: 0,
            assetAmount: 0,
        };

        if (message.assetType != null) {
            object.assetType = message.assetType;
        }
        if (message.assetAmount != null) {
            object.assetAmount = parseInt(message.assetAmount, 10);
        }
        return object;
    },
};

export const GameCard = {
    encode(object) {
        const message = {};
        if (object.gift != null) {
            message.gift = activity_cardgame_model.Gift.encode(object.gift);
        }
        if (object.seqNum != null) {
            if (object.seqNum !== "") {
                message.seqNum = String(object.seqNum);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            gift: null,
            seqNum: "",
        };

        if (message.gift != null) {
            object.gift = activity_cardgame_model.Gift.decode(message.gift);
        }
        if (message.seqNum != null) {
            object.seqNum = message.seqNum;
        }
        return object;
    },
};

export const TaskMultiple = {
    encode(object) {
        const message = {};
        if (object.totalNum != null) {
            if (object.totalNum !== 0) {
                message.totalNum = String(object.totalNum);
            }
        }
        if (object.finishNum != null) {
            if (object.finishNum !== 0) {
                message.finishNum = String(object.finishNum);
            }
        }
        if (object.claimNum != null) {
            if (object.claimNum !== 0) {
                message.claimNum = String(object.claimNum);
            }
        }
        if (object.codes != null) {
            if (!Array.isArray(object.codes)) {
                throw TypeError("codes: array expected");
            }
            if (object.codes.length > 0) {
                message.codes = [];
                for (let i = 0; i < object.codes.length; ++i) {
                    message.codes[i] = String(object.codes[i]);
                }
            }
        }
        if (object.finishTime != null) {
            if (object.finishTime !== 0) {
                message.finishTime = String(object.finishTime);
            }
        }
        if (object.currentTime != null) {
            if (object.currentTime !== 0) {
                message.currentTime = String(object.currentTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            totalNum: 0,
            finishNum: 0,
            claimNum: 0,
            codes: [],
            finishTime: 0,
            currentTime: 0,
        };

        if (message.totalNum != null) {
            object.totalNum = parseInt(message.totalNum, 10);
        }
        if (message.finishNum != null) {
            object.finishNum = parseInt(message.finishNum, 10);
        }
        if (message.claimNum != null) {
            object.claimNum = parseInt(message.claimNum, 10);
        }
        if (message.codes != null) {
            object.codes = [];
            for (let i = 0; i < message.codes.length; ++i) {
                    object.codes[i] = message.codes[i];
            }
        }
        if (message.finishTime != null) {
            object.finishTime = parseInt(message.finishTime, 10);
        }
        if (message.currentTime != null) {
            object.currentTime = parseInt(message.currentTime, 10);
        }
        return object;
    },
};

export const SignInContinueDay = {
    encode(object) {
        const message = {};
        if (object.assets != null) {
            if (!Array.isArray(object.assets)) {
                throw TypeError("assets: array expected");
            }
            if (object.assets.length > 0) {
                message.assets = [];
                for (let i = 0; i < object.assets.length; ++i) {
                    message.assets[i] = Asset.encode(object.assets[i]);
                }
            }
        }
        if (object.date != null) {
            if (object.date !== "") {
                message.date = String(object.date);
            }
        }
        if (object.continuousDay != null) {
            if (object.continuousDay !== 0) {
                message.continuousDay = String(object.continuousDay);
            }
        }
        if (object.double != null) {
            if (object.double !== 0) {
                message.double = String(object.double);
            }
        }
        if (object.participateFlag != null) {
            if (object.participateFlag !== false) {
                message.participateFlag = Boolean(object.participateFlag);
            }
        }
        if (object.multiples != null) {
            if (object.multiples !== 0) {
                message.multiples = Number(object.multiples);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            assets: [],
            date: "",
            continuousDay: 0,
            double: 0,
            participateFlag: false,
            multiples: 0,
        };

        if (message.assets != null) {
            object.assets = [];
            for (let i = 0; i < message.assets.length; ++i) {
                object.assets[i] = Asset.decode(message.assets[i]);
            }
        }
        if (message.date != null) {
            object.date = message.date;
        }
        if (message.continuousDay != null) {
            object.continuousDay = parseInt(message.continuousDay, 10);
        }
        if (message.double != null) {
            object.double = parseInt(message.double, 10);
        }
        if (message.participateFlag != null) {
            object.participateFlag = message.participateFlag;
        }
        if (message.multiples != null) {
            object.multiples = message.multiples;
        }
        return object;
    },
};

export const SignInContinueDayList = {
    encode(object) {
        const message = {};
        if (object.today != null) {
            if (object.today !== "") {
                message.today = String(object.today);
            }
        }
        if (object.list != null) {
            if (!Array.isArray(object.list)) {
                throw TypeError("list: array expected");
            }
            if (object.list.length > 0) {
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    message.list[i] = SignInContinueDay.encode(object.list[i]);
                }
            }
        }
        if (object.participateFlag != null) {
            if (object.participateFlag !== false) {
                message.participateFlag = Boolean(object.participateFlag);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            today: "",
            list: [],
            participateFlag: false,
        };

        if (message.today != null) {
            object.today = message.today;
        }
        if (message.list != null) {
            object.list = [];
            for (let i = 0; i < message.list.length; ++i) {
                object.list[i] = SignInContinueDay.decode(message.list[i]);
            }
        }
        if (message.participateFlag != null) {
            object.participateFlag = message.participateFlag;
        }
        return object;
    },
};

export const TaskFreshVideo = {
    encode(object) {
        const message = {};
        if (object.watchVideo != null) {
            if (object.watchVideo !== false) {
                message.watchVideo = Boolean(object.watchVideo);
            }
        }
        if (object.assetAmount != null) {
            if (object.assetAmount !== 0) {
                message.assetAmount = String(object.assetAmount);
            }
        }
        if (object.assetType != null) {
            if (object.assetType !== 0) {
                message.assetType = object.assetType;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            watchVideo: false,
            assetAmount: 0,
            assetType: 0,
        };

        if (message.watchVideo != null) {
            object.watchVideo = message.watchVideo;
        }
        if (message.assetAmount != null) {
            object.assetAmount = parseInt(message.assetAmount, 10);
        }
        if (message.assetType != null) {
            object.assetType = message.assetType;
        }
        return object;
    },
};

export const TaskPraise = {
    encode(object) {
        const message = {};
        if (object.isReject != null) {
            if (object.isReject !== false) {
                message.isReject = Boolean(object.isReject);
            }
        }
        if (object.assets != null) {
            if (!Array.isArray(object.assets)) {
                throw TypeError("assets: array expected");
            }
            if (object.assets.length > 0) {
                message.assets = [];
                for (let i = 0; i < object.assets.length; ++i) {
                    message.assets[i] = Asset.encode(object.assets[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isReject: false,
            assets: [],
        };

        if (message.isReject != null) {
            object.isReject = message.isReject;
        }
        if (message.assets != null) {
            object.assets = [];
            for (let i = 0; i < message.assets.length; ++i) {
                object.assets[i] = Asset.decode(message.assets[i]);
            }
        }
        return object;
    },
};

export const VideoBuy = {
    encode(object) {
        const message = {};
        if (object.videoID != null) {
            if (object.videoID !== "") {
                message.videoID = String(object.videoID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            videoID: "",
        };

        if (message.videoID != null) {
            object.videoID = message.videoID;
        }
        return object;
    },
};

export const PraiseExtra = {
    encode(object) {
        const message = {};
        if (object.device != null) {
            if (object.device !== "") {
                message.device = String(object.device);
            }
        }
        if (object.imageInfo != null) {
            message.imageInfo = ImageInfo.encode(object.imageInfo);
        }
        return message;
    },

    decode(message) {
        const object = {
            device: "",
            imageInfo: null,
        };

        if (message.device != null) {
            object.device = message.device;
        }
        if (message.imageInfo != null) {
            object.imageInfo = ImageInfo.decode(message.imageInfo);
        }
        return object;
    },
};

export const ImageInfo = {
    encode(object) {
        const message = {};
        if (object.size != null) {
            if (object.size !== 0) {
                message.size = String(object.size);
            }
        }
        if (object.hash != null) {
            if (object.hash !== "") {
                message.hash = String(object.hash);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            size: 0,
            hash: "",
            imageURL: "",
        };

        if (message.size != null) {
            object.size = parseInt(message.size, 10);
        }
        if (message.hash != null) {
            object.hash = message.hash;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        return object;
    },
};

export const UserRewardVideo = {
    encode(object) {
        const message = {};
        if (object.transactionID != null) {
            if (object.transactionID !== "") {
                message.transactionID = String(object.transactionID);
            }
        }
        if (object.adPosition != null) {
            if (object.adPosition !== "") {
                message.adPosition = String(object.adPosition);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            transactionID: "",
            adPosition: "",
        };

        if (message.transactionID != null) {
            object.transactionID = message.transactionID;
        }
        if (message.adPosition != null) {
            object.adPosition = message.adPosition;
        }
        return object;
    },
};

export const XianwanGameExtra = {
    encode(object) {
        const message = {};
        if (object.taskID != null) {
            if (object.taskID !== "") {
                message.taskID = String(object.taskID);
            }
        }
        if (object.label != null) {
            if (object.label !== "") {
                message.label = String(object.label);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            taskID: "",
            label: "",
        };

        if (message.taskID != null) {
            object.taskID = message.taskID;
        }
        if (message.label != null) {
            object.label = message.label;
        }
        return object;
    },
};

export const TaskSummary = {
    encode(object) {
        const message = {};
        let ext_ = false;
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.unclaimed != null) {
            if (!Array.isArray(object.unclaimed)) {
                throw TypeError("unclaimed: array expected");
            }
            if (object.unclaimed.length > 0) {
                message.unclaimed = [];
                for (let i = 0; i < object.unclaimed.length; ++i) {
                    message.unclaimed[i] = Asset.encode(object.unclaimed[i]);
                }
            }
        }
        if (object.price4EachCompletion != null) {
            if (!Array.isArray(object.price4EachCompletion)) {
                throw TypeError("price4EachCompletion: array expected");
            }
            if (object.price4EachCompletion.length > 0) {
                message.price4EachCompletion = [];
                for (let i = 0; i < object.price4EachCompletion.length; ++i) {
                    message.price4EachCompletion[i] = Asset.encode(object.price4EachCompletion[i]);
                }
            }
        }
        if (object.joinCount != null) {
            if (object.joinCount !== 0) {
                message.joinCount = String(object.joinCount);
            }
        }
        if (object.videoBuySummary != null && !ext_) {
            message.videoBuySummary = VideoBuySummary.encode(object.videoBuySummary);
            ext_ = true;
        }
        if (object.praiseSummary != null && !ext_) {
            message.praiseSummary = PraiseSummary.encode(object.praiseSummary);
            ext_ = true;
        }
        if (object.taskMultiple != null && !ext_) {
            message.taskMultiple = TaskMultiple.encode(object.taskMultiple);
            ext_ = true;
        }
        if (object.fresherCountDownSummary != null && !ext_) {
            message.fresherCountDownSummary = FresherCountDownSummary.encode(object.fresherCountDownSummary);
            ext_ = true;
        }
        if (object.signInSummary != null && !ext_) {
            message.signInSummary = SignInSummary.encode(object.signInSummary);
            ext_ = true;
        }
        if (object.exchangeSummary != null && !ext_) {
            message.exchangeSummary = ExchangeSummary.encode(object.exchangeSummary);
            ext_ = true;
        }
        if (object.xianwanGameExtra != null && !ext_) {
            message.xianwanGameExtra = XianwanGameExtra.encode(object.xianwanGameExtra);
            ext_ = true;
        }
        return message;
    },

    decode(message) {
        const object = {
            status: 0,
            taskType: 0,
            unclaimed: [],
            price4EachCompletion: [],
            joinCount: 0,
        };

        if (message.status != null) {
            object.status = message.status;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.unclaimed != null) {
            object.unclaimed = [];
            for (let i = 0; i < message.unclaimed.length; ++i) {
                object.unclaimed[i] = Asset.decode(message.unclaimed[i]);
            }
        }
        if (message.price4EachCompletion != null) {
            object.price4EachCompletion = [];
            for (let i = 0; i < message.price4EachCompletion.length; ++i) {
                object.price4EachCompletion[i] = Asset.decode(message.price4EachCompletion[i]);
            }
        }
        if (message.joinCount != null) {
            object.joinCount = parseInt(message.joinCount, 10);
        }
        if (message.videoBuySummary != null) {
            object.videoBuySummary = VideoBuySummary.decode(message.videoBuySummary);
                object.ext = "videoBuySummary";
        }
        if (message.praiseSummary != null) {
            object.praiseSummary = PraiseSummary.decode(message.praiseSummary);
                object.ext = "praiseSummary";
        }
        if (message.taskMultiple != null) {
            object.taskMultiple = TaskMultiple.decode(message.taskMultiple);
                object.ext = "taskMultiple";
        }
        if (message.fresherCountDownSummary != null) {
            object.fresherCountDownSummary = FresherCountDownSummary.decode(message.fresherCountDownSummary);
                object.ext = "fresherCountDownSummary";
        }
        if (message.signInSummary != null) {
            object.signInSummary = SignInSummary.decode(message.signInSummary);
                object.ext = "signInSummary";
        }
        if (message.exchangeSummary != null) {
            object.exchangeSummary = ExchangeSummary.decode(message.exchangeSummary);
                object.ext = "exchangeSummary";
        }
        if (message.xianwanGameExtra != null) {
            object.xianwanGameExtra = XianwanGameExtra.decode(message.xianwanGameExtra);
                object.ext = "xianwanGameExtra";
        }
        return object;
    },
};

export const VideoBuySummary = {
    encode(object) {
        const message = {};
        if (object.todayCoinAmount != null) {
            if (object.todayCoinAmount !== 0) {
                message.todayCoinAmount = String(object.todayCoinAmount);
            }
        }
        if (object.totalCoinAmount != null) {
            if (object.totalCoinAmount !== 0) {
                message.totalCoinAmount = String(object.totalCoinAmount);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            todayCoinAmount: 0,
            totalCoinAmount: 0,
        };

        if (message.todayCoinAmount != null) {
            object.todayCoinAmount = parseInt(message.todayCoinAmount, 10);
        }
        if (message.totalCoinAmount != null) {
            object.totalCoinAmount = parseInt(message.totalCoinAmount, 10);
        }
        return object;
    },
};

export const ExchangeSummary = {
    encode(object) {
        const message = {};
        if (object.isExchangeFreshCash != null) {
            if (object.isExchangeFreshCash !== 0) {
                message.isExchangeFreshCash = String(object.isExchangeFreshCash);
            }
        }
        if (object.isExchangeSecondStageFreshCash != null) {
            if (object.isExchangeSecondStageFreshCash !== 0) {
                message.isExchangeSecondStageFreshCash = String(object.isExchangeSecondStageFreshCash);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isExchangeFreshCash: 0,
            isExchangeSecondStageFreshCash: 0,
        };

        if (message.isExchangeFreshCash != null) {
            object.isExchangeFreshCash = parseInt(message.isExchangeFreshCash, 10);
        }
        if (message.isExchangeSecondStageFreshCash != null) {
            object.isExchangeSecondStageFreshCash = parseInt(message.isExchangeSecondStageFreshCash, 10);
        }
        return object;
    },
};

export const FresherCountDownSummary = {
    encode(object) {
        const message = {};
        if (object.currentTime != null) {
            if (object.currentTime !== 0) {
                message.currentTime = String(object.currentTime);
            }
        }
        if (object.expireTime != null) {
            if (object.expireTime !== 0) {
                message.expireTime = String(object.expireTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            currentTime: 0,
            expireTime: 0,
        };

        if (message.currentTime != null) {
            object.currentTime = parseInt(message.currentTime, 10);
        }
        if (message.expireTime != null) {
            object.expireTime = parseInt(message.expireTime, 10);
        }
        return object;
    },
};

export const SignInSummary = {
    encode(object) {
        const message = {};
        if (object.continuousDay != null) {
            if (object.continuousDay !== 0) {
                message.continuousDay = String(object.continuousDay);
            }
        }
        if (object.yesterdayStatus != null) {
            if (object.yesterdayStatus !== 0) {
                message.yesterdayStatus = object.yesterdayStatus;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            continuousDay: 0,
            yesterdayStatus: 0,
        };

        if (message.continuousDay != null) {
            object.continuousDay = parseInt(message.continuousDay, 10);
        }
        if (message.yesterdayStatus != null) {
            object.yesterdayStatus = message.yesterdayStatus;
        }
        return object;
    },
};

export const PraiseSummary = {
    encode(object) {
        const message = {};
        if (object.isReject != null) {
            if (object.isReject !== false) {
                message.isReject = Boolean(object.isReject);
            }
        }
        if (object.isShow != null) {
            if (object.isShow !== false) {
                message.isShow = Boolean(object.isShow);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isReject: false,
            isShow: false,
        };

        if (message.isReject != null) {
            object.isReject = message.isReject;
        }
        if (message.isShow != null) {
            object.isShow = message.isShow;
        }
        return object;
    },
};

export const TaskVideoBuy = {
    encode(object) {
        const message = {};
        if (object.cycleTime != null) {
            if (object.cycleTime !== 0) {
                message.cycleTime = String(object.cycleTime);
            }
        }
        if (object.totalTime != null) {
            if (object.totalTime !== 0) {
                message.totalTime = String(object.totalTime);
            }
        }
        if (object.alreadyTime != null) {
            if (object.alreadyTime !== 0) {
                message.alreadyTime = String(object.alreadyTime);
            }
        }
        if (object.coinAmount != null) {
            if (object.coinAmount !== 0) {
                message.coinAmount = String(object.coinAmount);
            }
        }
        if (object.leftCoinAmount != null) {
            if (object.leftCoinAmount !== 0) {
                message.leftCoinAmount = String(object.leftCoinAmount);
            }
        }
        if (object.totalCoinAmount != null) {
            if (object.totalCoinAmount !== 0) {
                message.totalCoinAmount = String(object.totalCoinAmount);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            cycleTime: 0,
            totalTime: 0,
            alreadyTime: 0,
            coinAmount: 0,
            leftCoinAmount: 0,
            totalCoinAmount: 0,
        };

        if (message.cycleTime != null) {
            object.cycleTime = parseInt(message.cycleTime, 10);
        }
        if (message.totalTime != null) {
            object.totalTime = parseInt(message.totalTime, 10);
        }
        if (message.alreadyTime != null) {
            object.alreadyTime = parseInt(message.alreadyTime, 10);
        }
        if (message.coinAmount != null) {
            object.coinAmount = parseInt(message.coinAmount, 10);
        }
        if (message.leftCoinAmount != null) {
            object.leftCoinAmount = parseInt(message.leftCoinAmount, 10);
        }
        if (message.totalCoinAmount != null) {
            object.totalCoinAmount = parseInt(message.totalCoinAmount, 10);
        }
        return object;
    },
};

export const Praise = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.code != null) {
            if (object.code !== "") {
                message.code = String(object.code);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        if (object.device != null) {
            if (object.device !== "") {
                message.device = String(object.device);
            }
        }
        if (object.hash != null) {
            if (object.hash !== "") {
                message.hash = String(object.hash);
            }
        }
        if (object.size != null) {
            if (object.size !== 0) {
                message.size = String(object.size);
            }
        }
        if (object.operatorID != null) {
            if (object.operatorID !== "") {
                message.operatorID = String(object.operatorID);
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = String(object.createdTime);
            }
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = String(object.updatedTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userID: "",
            status: 0,
            taskType: 0,
            code: "",
            imageURL: "",
            device: "",
            hash: "",
            size: 0,
            operatorID: "",
            createdTime: 0,
            updatedTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.code != null) {
            object.code = message.code;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        if (message.device != null) {
            object.device = message.device;
        }
        if (message.hash != null) {
            object.hash = message.hash;
        }
        if (message.size != null) {
            object.size = parseInt(message.size, 10);
        }
        if (message.operatorID != null) {
            object.operatorID = message.operatorID;
        }
        if (message.createdTime != null) {
            object.createdTime = parseInt(message.createdTime, 10);
        }
        if (message.updatedTime != null) {
            object.updatedTime = parseInt(message.updatedTime, 10);
        }
        return object;
    },
};

export const SearchTaskRedPacketInfo = {
    encode(object) {
        const message = {};
        if (object.sequenceID != null) {
            if (object.sequenceID !== "") {
                message.sequenceID = String(object.sequenceID);
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.conditionID != null) {
            if (object.conditionID !== "") {
                message.conditionID = String(object.conditionID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            sequenceID: "",
            amount: 0,
            status: 0,
            conditionID: "",
        };

        if (message.sequenceID != null) {
            object.sequenceID = message.sequenceID;
        }
        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.conditionID != null) {
            object.conditionID = message.conditionID;
        }
        return object;
    },
};

export const SearchTaskConditionInfo = {
    encode(object) {
        const message = {};
        if (object.sequenceID != null) {
            if (object.sequenceID !== "") {
                message.sequenceID = String(object.sequenceID);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.conditionID != null) {
            if (object.conditionID !== "") {
                message.conditionID = String(object.conditionID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            sequenceID: "",
            status: 0,
            conditionID: "",
        };

        if (message.sequenceID != null) {
            object.sequenceID = message.sequenceID;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.conditionID != null) {
            object.conditionID = message.conditionID;
        }
        return object;
    },
};

export const PullNewExtension = {
    encode(object) {
        const message = {};
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.assetAmount != null) {
            if (object.assetAmount !== 0) {
                message.assetAmount = String(object.assetAmount);
            }
        }
        if (object.assetType != null) {
            if (object.assetType !== 0) {
                message.assetType = object.assetType;
            }
        }
        if (object.hasRegisteredInApp != null) {
            if (object.hasRegisteredInApp !== false) {
                message.hasRegisteredInApp = Boolean(object.hasRegisteredInApp);
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = String(object.createdTime);
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = String(object.expiredTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            nickname: "",
            avatar: "",
            assetAmount: 0,
            assetType: 0,
            hasRegisteredInApp: false,
            createdTime: 0,
            expiredTime: 0,
        };

        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.assetAmount != null) {
            object.assetAmount = parseInt(message.assetAmount, 10);
        }
        if (message.assetType != null) {
            object.assetType = message.assetType;
        }
        if (message.hasRegisteredInApp != null) {
            object.hasRegisteredInApp = message.hasRegisteredInApp;
        }
        if (message.createdTime != null) {
            object.createdTime = parseInt(message.createdTime, 10);
        }
        if (message.expiredTime != null) {
            object.expiredTime = parseInt(message.expiredTime, 10);
        }
        return object;
    },
};

export const QTTCPCRedPacket = {
    encode(object) {
        const message = {};
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.totalAmount != null) {
            if (object.totalAmount !== 0) {
                message.totalAmount = String(object.totalAmount);
            }
        }
        if (object.currentAmount != null) {
            if (object.currentAmount !== 0) {
                message.currentAmount = String(object.currentAmount);
            }
        }
        if (object.nextAmount != null) {
            if (object.nextAmount !== 0) {
                message.nextAmount = String(object.nextAmount);
            }
        }
        if (object.receivedAmount != null) {
            if (object.receivedAmount !== 0) {
                message.receivedAmount = String(object.receivedAmount);
            }
        }
        if (object.todayReceivedAmount != null) {
            if (object.todayReceivedAmount !== 0) {
                message.todayReceivedAmount = String(object.todayReceivedAmount);
            }
        }
        if (object.todayTotalTimes != null) {
            if (object.todayTotalTimes !== 0) {
                message.todayTotalTimes = String(object.todayTotalTimes);
            }
        }
        if (object.todayFinishedTimes != null) {
            if (object.todayFinishedTimes !== 0) {
                message.todayFinishedTimes = String(object.todayFinishedTimes);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            status: 0,
            totalAmount: 0,
            currentAmount: 0,
            nextAmount: 0,
            receivedAmount: 0,
            todayReceivedAmount: 0,
            todayTotalTimes: 0,
            todayFinishedTimes: 0,
        };

        if (message.status != null) {
            object.status = message.status;
        }
        if (message.totalAmount != null) {
            object.totalAmount = parseInt(message.totalAmount, 10);
        }
        if (message.currentAmount != null) {
            object.currentAmount = parseInt(message.currentAmount, 10);
        }
        if (message.nextAmount != null) {
            object.nextAmount = parseInt(message.nextAmount, 10);
        }
        if (message.receivedAmount != null) {
            object.receivedAmount = parseInt(message.receivedAmount, 10);
        }
        if (message.todayReceivedAmount != null) {
            object.todayReceivedAmount = parseInt(message.todayReceivedAmount, 10);
        }
        if (message.todayTotalTimes != null) {
            object.todayTotalTimes = parseInt(message.todayTotalTimes, 10);
        }
        if (message.todayFinishedTimes != null) {
            object.todayFinishedTimes = parseInt(message.todayFinishedTimes, 10);
        }
        return object;
    },
};

export const SaveMoneyCardRedPacketTask = {
    encode(object) {
        const message = {};
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        if (object.activityTime != null) {
            if (object.activityTime !== 0) {
                message.activityTime = String(object.activityTime);
            }
        }
        if (object.category != null) {
            if (object.category !== 0) {
                message.category = object.category;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            taskStatus: 0,
            amount: 0,
            activityTime: 0,
            category: 0,
        };

        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        if (message.activityTime != null) {
            object.activityTime = parseInt(message.activityTime, 10);
        }
        if (message.category != null) {
            object.category = message.category;
        }
        return object;
    },
};

export const SaveMoneyCardRedPacket = {
    encode(object) {
        const message = {};
        if (object.taskDetail != null) {
            message.taskDetail = SaveMoneyCardRedPacketTask.encode(object.taskDetail);
        }
        if (object.orderDetail != null) {
            message.orderDetail = order_model.OrderDetail.encode(object.orderDetail);
        }
        return message;
    },

    decode(message) {
        const object = {
            taskDetail: null,
            orderDetail: null,
        };

        if (message.taskDetail != null) {
            object.taskDetail = SaveMoneyCardRedPacketTask.decode(message.taskDetail);
        }
        if (message.orderDetail != null) {
            object.orderDetail = order_model.OrderDetail.decode(message.orderDetail);
        }
        return object;
    },
};

export const LotteryTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.totalAmount != null) {
            if (object.totalAmount !== 0) {
                message.totalAmount = String(object.totalAmount);
            }
        }
        if (object.claimedAmount != null) {
            if (object.claimedAmount !== 0) {
                message.claimedAmount = String(object.claimedAmount);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskType: 0,
            totalAmount: 0,
            claimedAmount: 0,
            taskStatus: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.totalAmount != null) {
            object.totalAmount = parseInt(message.totalAmount, 10);
        }
        if (message.claimedAmount != null) {
            object.claimedAmount = parseInt(message.claimedAmount, 10);
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        return object;
    },
};

export const OpenMembershipTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.rewardAmount != null) {
            if (object.rewardAmount !== 0) {
                message.rewardAmount = String(object.rewardAmount);
            }
        }
        if (object.subTasks != null) {
            if (!Array.isArray(object.subTasks)) {
                throw TypeError("subTasks: array expected");
            }
            if (object.subTasks.length > 0) {
                message.subTasks = [];
                for (let i = 0; i < object.subTasks.length; ++i) {
                    message.subTasks[i] = OpenMembershipSubTask.encode(object.subTasks[i]);
                }
            }
        }
        if (object.finishTime != null) {
            if (object.finishTime !== 0) {
                message.finishTime = String(object.finishTime);
            }
        }
        if (object.isCanceled != null) {
            if (object.isCanceled !== false) {
                message.isCanceled = Boolean(object.isCanceled);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            rewardAmount: 0,
            subTasks: [],
            finishTime: 0,
            isCanceled: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.rewardAmount != null) {
            object.rewardAmount = parseInt(message.rewardAmount, 10);
        }
        if (message.subTasks != null) {
            object.subTasks = [];
            for (let i = 0; i < message.subTasks.length; ++i) {
                object.subTasks[i] = OpenMembershipSubTask.decode(message.subTasks[i]);
            }
        }
        if (message.finishTime != null) {
            object.finishTime = parseInt(message.finishTime, 10);
        }
        if (message.isCanceled != null) {
            object.isCanceled = message.isCanceled;
        }
        return object;
    },
};

export const OpenMembershipSubTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = String(object.startTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            startTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.startTime != null) {
            object.startTime = parseInt(message.startTime, 10);
        }
        return object;
    },
};

export const FreeBuyTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.expireTime != null) {
            if (object.expireTime !== 0) {
                message.expireTime = String(object.expireTime);
            }
        }
        if (object.taskType != null) {
            if (object.taskType !== 0) {
                message.taskType = object.taskType;
            }
        }
        if (object.subTasks != null) {
            if (!Array.isArray(object.subTasks)) {
                throw TypeError("subTasks: array expected");
            }
            if (object.subTasks.length > 0) {
                message.subTasks = [];
                for (let i = 0; i < object.subTasks.length; ++i) {
                    message.subTasks[i] = FreeBuySubTask.encode(object.subTasks[i]);
                }
            }
        }
        if (object.rewardAmount != null) {
            if (object.rewardAmount !== 0) {
                message.rewardAmount = String(object.rewardAmount);
            }
        }
        if (object.assetType != null) {
            if (object.assetType !== 0) {
                message.assetType = object.assetType;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            expireTime: 0,
            taskType: 0,
            subTasks: [],
            rewardAmount: 0,
            assetType: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.expireTime != null) {
            object.expireTime = parseInt(message.expireTime, 10);
        }
        if (message.taskType != null) {
            object.taskType = message.taskType;
        }
        if (message.subTasks != null) {
            object.subTasks = [];
            for (let i = 0; i < message.subTasks.length; ++i) {
                object.subTasks[i] = FreeBuySubTask.decode(message.subTasks[i]);
            }
        }
        if (message.rewardAmount != null) {
            object.rewardAmount = parseInt(message.rewardAmount, 10);
        }
        if (message.assetType != null) {
            object.assetType = message.assetType;
        }
        return object;
    },
};

export const CPCFreeBuyTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.expireTime != null) {
            if (object.expireTime !== 0) {
                message.expireTime = String(object.expireTime);
            }
        }
        if (object.itemID != null) {
            if (object.itemID !== "") {
                message.itemID = String(object.itemID);
            }
        }
        if (object.orderLink != null) {
            if (object.orderLink !== "") {
                message.orderLink = String(object.orderLink);
            }
        }
        if (object.magicItemBindID != null) {
            if (object.magicItemBindID !== "") {
                message.magicItemBindID = String(object.magicItemBindID);
            }
        }
        if (object.cpcTimes != null) {
            if (object.cpcTimes !== 0) {
                message.cpcTimes = String(object.cpcTimes);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            expireTime: 0,
            itemID: "",
            orderLink: "",
            magicItemBindID: "",
            cpcTimes: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.expireTime != null) {
            object.expireTime = parseInt(message.expireTime, 10);
        }
        if (message.itemID != null) {
            object.itemID = message.itemID;
        }
        if (message.orderLink != null) {
            object.orderLink = message.orderLink;
        }
        if (message.magicItemBindID != null) {
            object.magicItemBindID = message.magicItemBindID;
        }
        if (message.cpcTimes != null) {
            object.cpcTimes = parseInt(message.cpcTimes, 10);
        }
        return object;
    },
};

export const CPCLuckyBagTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.expireTime != null) {
            if (object.expireTime !== 0) {
                message.expireTime = String(object.expireTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            expireTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.expireTime != null) {
            object.expireTime = parseInt(message.expireTime, 10);
        }
        return object;
    },
};

export const FreeBuySubTask = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.taskStatus != null) {
            if (object.taskStatus !== 0) {
                message.taskStatus = object.taskStatus;
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = String(object.startTime);
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = String(object.endTime);
            }
        }
        if (object.rewardAmount != null) {
            if (object.rewardAmount !== 0) {
                message.rewardAmount = String(object.rewardAmount);
            }
        }
        if (object.assetType != null) {
            if (object.assetType !== 0) {
                message.assetType = object.assetType;
            }
        }
        if (object.nextOne != null) {
            message.nextOne = FreeBuyTask.encode(object.nextOne);
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            taskStatus: 0,
            startTime: 0,
            endTime: 0,
            rewardAmount: 0,
            assetType: 0,
            nextOne: null,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.taskStatus != null) {
            object.taskStatus = message.taskStatus;
        }
        if (message.startTime != null) {
            object.startTime = parseInt(message.startTime, 10);
        }
        if (message.endTime != null) {
            object.endTime = parseInt(message.endTime, 10);
        }
        if (message.rewardAmount != null) {
            object.rewardAmount = parseInt(message.rewardAmount, 10);
        }
        if (message.assetType != null) {
            object.assetType = message.assetType;
        }
        if (message.nextOne != null) {
            object.nextOne = FreeBuyTask.decode(message.nextOne);
        }
        return object;
    },
};


export const TaskType = {
    TASK_TYPE_UNDEFINED: 0,
    TASK_TYPE_FRESHER: 1,
    TASK_TYPE_SHARER_BONUS: 2,
    TASK_TYPE_HELPER_BONUS: 3,
    TASK_TYPE_DISCOUNT: 4,
    TASK_TYPE_FIRST_BELL: 5,
    TASK_TYPE_WATCHING_VIDEO_TUTORIAL_BONUS: 8,
    TASK_TYPE_SIGN_IN: 9,
    TASK_TYPE_SEARCH_ONCE: 10,
    TASK_TYPE_BUY_ONCE: 11,
    TASK_TYPE_SCAN_RECOMMEND_DAILY: 12,
    TASK_TYPE_ACCEPT_COUPON_ONCE: 13,
    TASK_TYPE_SHARE_ITEM_ONCE: 14,
    TASK_TYPE_DRAW_RED_PACKET_POOL_BONUS: 15,
    TASK_TYPE_SHARER_BONUS_V2: 16,
    TASK_TYPE_SHARE_ITEM_DAILY: 100,
    TASK_TYPE_READ_PUSH_DAILY: 101,
    TASK_TYPE_SCAN_RECOMMEND_ONCE: 102,
    TASK_TYPE_BIND_TAOBAO_ONCE: 103,
    TASK_TYPE_AUTHORIZED_MESSAGE_PUSH_ONCE: 104,
    TASK_TYPE_GIVE_PRAISE_ONCE: 105,
    TASK_TYPE_TAKE_ORDER_DAILY: 106,
    TASK_TYPE_GAME_ON_TIME_CLAIM: 107,
    TASK_TYPE_NEW_USER_CLAIM: 108,
    TASK_TYPE_NEW_INFORMATION: 109,
    TASK_TYPE_GAME_SIGN_IN: 110,
    TASK_TYPE_PROMOTION_BONUS: 111,
    TASK_TYPE_ANSWER_ONCE: 112,
    TASK_TYPE_WITHDRAW_ONCE: 113,
    TASK_TYPE_COMPLETE_NEW_TASK_ONCE: 114,
    TASK_TYPE_THREE_DAYS_SIGN_IN: 115,
    TASK_TYPE_FRESHER_RED_PACKET: 116,
    TASK_TYPE_INVITE_FIRST_SHARE: 117,
    TASK_TYPE_SHARER_V2: 118,
    TASK_TYPE_INVITE_FIRST_LOGIN: 119,
    TASK_TYPE_INVITE_FIRST_BUY: 120,
    TASK_TYPE_INVITE_ACCUMULATED_MIAO_COIN_LEVEL_1: 121,
    TASK_TYPE_INVITE_ACCUMULATED_MIAO_COIN_LEVEL_2: 122,
    TASK_TYPE_INVITE_ACCUMULATED_MIAO_COIN_LEVEL_3: 123,
    TASK_TYPE_INVITE_ACCUMULATED_MEMBERSHIP_DURATION_LEVEL_1: 124,
    TASK_TYPE_INVITE_ACCUMULATED_MEMBERSHIP_DURATION_LEVEL_2: 125,
    TASK_TYPE_INVITE_ACCUMULATED_MEMBERSHIP_DURATION_LEVEL_3: 126,
    TASK_TYPE_COUPON_BONUS: 130,
    TASK_TYPE_NEW_CUSTOME_GIFT_MIAO_COIN: 131,
    TASK_TYPE_DAILY_VIDEO_REWARD_COIN: 132,
    TASK_TYPE_VIDEO_REWARD_DOUBLE_COIN: 133,
    TASK_TYPE_FRESHER_THREE_GIFT: 134,
    TASK_TYPE_MIAO_COIN_ORDER_BONUS: 135,
    TASK_TYPE_GAME_ON_TIME_CLAIM_MIAO_COIN: 136,
    TASK_TYPE_GAME_CONTINUOUS_SIGN_IN: 137,
    TASK_TYPE_FIRST_WATCH_VIDEO_ONCE: 138,
    TASK_TYPE_WATCH_VIDEO_FOR_SIX_ONCE: 139,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN: 140,
    TASK_TYPE_APP_HELP: 150,
    TASK_TYPE_CPC_GAME_DAILY: 151,
    TASK_TYPE_PLANT_RED_PACKET_GAME_MIAO_COIN: 152,
    TASK_TYPE_PLANT_RED_PACKET_GAME_BONUS_FOR_ONE_PACKET: 153,
    TASK_TYPE_PLANT_RED_PACKET_GAME_BONUS_FOR_FIVE_PACKET: 154,
    TASK_TYPE_MIAO_COIN_FOR_ONE_RED_PACKET: 155,
    TASK_TYPE_MIAO_COIN_FOR_THREE_RED_PACKET: 156,
    TASK_TYPE_FRESHER_CUT_DOWN: 157,
    TASK_TYPE_DAILY_VISIT_FOR_CLAIM: 158,
    TASK_TYPE_PULL_NEW_POSTER_SHARE: 159,
    TASK_TYPE_COPY_ITEMS_TITLE: 160,
    TASK_TYPE_MIAO_COIN_FOR_ZERO_POINT_FIVE_RED_PACKET: 161,
    TASK_TYPE_MIAO_COIN_FOR_OTHER_ONE_CASH: 162,
    TASK_TYPE_MIAO_COIN_FOR_TWO_CASH: 163,
    TASK_TYPE_MIAO_COIN_SHARE_PROFIT: 164,
    TASK_TYPE_MIAO_COIN_ANSWER_GAME: 165,
    TASK_TYPE_MIAO_COIN_VIDEO_FOLLOW_AUTHORS: 166,
    TASK_TYPE_MIAO_COIN_FOR_VIDEO_PRAISE: 167,
    TASK_TYPE_MIAO_COIN_STROLL_JD: 168,
    TASK_TYPE_MIAO_COIN_STROLL_TAOBAO: 169,
    TASK_TYPE_MIAO_COIN_RED_PACKET: 170,
    TASK_TYPE_MIAO_COIN_TAOBAO_PREFERENTIAL: 171,
    TASK_TYPE_MIAO_COIN_JD_ASSEMBLE: 172,
    TASK_TYPE_MIAO_COIN_TIAN_MAO: 173,
    TASK_TYPE_MIAO_COIN_JD_FLASH_SALE: 174,
    TASK_TYPE_MIAO_COIN_SHARE_PROFIT_ONE: 175,
    TASK_TYPE_MIAO_COIN_SHARE_PROFIT_TWO: 176,
    TASK_TYPE_MIAO_COIN_SHARE_PROFIT_THREE: 177,
    TASK_TYPE_FOR_PIN_DUO_DUO_MIAO_COIN: 178,
    TASK_TYPE_FOR_PHONE_CHARGE_MIAO_COIN: 179,
    TASK_TYPE_MIAO_COIN_FOR_ZERO_POINT_THREE_RED_PACKET: 180,
    TASK_TYPE_FOR_PIN_DUO_DUO_SALES_PROMOTION: 181,
    TASK_TYPE_MIAO_COIN_JU_TAOBAO_ASSEMBLY: 182,
    TASK_TYPE_MIAO_COIN_CLAIM_JINGDONG_FLASH_SALE: 183,
    TASK_TYPE_MIAO_COIN_TMALL_MARKET: 184,
    TASK_TYPE_MIAO_COIN_DISMANTLE_A_RED_ENVELOPE: 185,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_EXCLUSIVE_FLOOR_ENLARGE_FLOW_1: 186,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_EXCLUSIVE_FLOOR_ENLARGE_FLOW_2: 187,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_EXCLUSIVE_FLOOR_ENLARGE_FLOW_3: 188,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_EXCLUSIVE_FLOOR_ENLARGE_FLOW_4: 189,
    TASK_TYPE_MIAO_COIN_TMALL_GLOBAL_BLACK_FRIDAY_CARNIVAL: 190,
    TASK_TYPE_MIAO_COIN_JINGDONG_GLOBAL_BLACK_FRIDAY_CARNIVAL: 191,
    TASK_TYPE_MIAO_COIN_DAILY_HANG_OUT_AT_TMALL_1212: 192,
    TASK_TYPE_MIAO_COIN_FRESHER_FREE_BUY: 193,
    TASK_TYPE_MIAO_COIN_FRESHER_ALLOWANCE: 194,
    TASK_TYPE_SHARER_V3: 200,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2: 201,
    TASK_TYPE_PULL_NEW_WEEK_BUY: 202,
    TASK_TYPE_PULL_NEW_MONTH_BUY: 203,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2_STEP1: 211,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2_STEP2: 212,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2_STEP3: 213,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2_STEP4: 214,
    TASK_TYPE_COLLECT_PRODUCT_ONCE: 215,
    TASK_TYPE_EXPERIENCE_SHOPPING_CART_TECH: 216,
    TASK_TYPE_ONCE_TASK_ORDER: 217,
    TASK_TYPE_GET_FRIEND_HELP: 218,
    TASK_TYPE_RECEIVING_ORDERS_IN_FULL_BONUS: 219,
    TASK_TYPE_FOR_FRIEND_HELP_ONCE: 220,
    TASK_TYPE_DAILY_WATCH_VIDEO_FOR_COIN_V2_STEP5: 221,
    TASK_TYPE_MIAO_COIN_COPY_ITEM_TITLE_V2: 222,
    TASK_TYPE_FOR_PULL_NEW_CHARGE: 250,
    TASK_TYPE_FOR_PULL_NEW_CHARGE_POPUP: 251,
    TASK_TYPE_FOR_PULL_NEW_MIAO_COIN: 252,
    TASK_TYPE_MEMBERSHIP_INVITE_FIRST_BUY: 253,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_1: 254,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_2: 255,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_3: 256,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_4: 257,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_5: 258,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_6: 259,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_7: 260,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_8: 261,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_9: 262,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_LIFE_RIGHTS_10: 263,
    TASK_TYPE_SHARER_V4: 300,
    TASK_TYPE_MEMBERSHIP_ORDER_BONUS_SELF_BUY: 301,
    TASK_TYPE_MEMBERSHIP_ORDER_BONUS_SHARE_BUY: 302,
    TASK_TYPE_MEMBERSHIP_FAMILY_TAOBAO_AUTHORIZED: 303,
    TASK_TYPE_MEMBERSHIP_FAMILY_TAOBAO_ORDER: 304,
    TASK_TYPE_MEMBERSHIP_FAMILY_JINGDONG_OR_PINDUODUO_ORDER: 305,
    TASK_TYPE_MEMBERSHIP_FAMILY_WAIMAI_ORDER: 306,
    TASK_TYPE_MEMBERSHIP_FAMILY_FIRST_INVITE: 307,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_INVITE_REGISTER: 308,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_WAIMAI_FIRST_ORDER: 309,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_TAOBAO_FIRST_ORDER: 310,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_PDD_OR_JD_FIRST_ORDER: 311,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_NORMAL_ORDER: 312,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_ACCUMULATED_EARN_10000_MIAO_COIN: 313,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_FIRST_SHARE_ACTIVITY_TO_WECHAT: 314,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_FIRST_ENTER_ACTIVITY: 315,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_VISIT_PAGE_24_HOURS_LUCKY_REWARD: 316,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_VISIT_PAGE_48_HOURS_LUCKY_REWARD: 317,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_ONE_VISIT_PAGE_LUCKY_REWARD: 318,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_POTENTIAL_CONTRIBUTE_REWARD: 319,
    TASK_TYPE_WAIMAI_COUPON: 320,
    TASK_TYPE_FRESHER_30_PHONE_BILL_CUT_DOWN: 321,
    TASK_TYPE_FRESHER_30_RECEIVED_LIFE_RIGHTS_TRANSPORTATION_CARD: 322,
    TASK_TYPE_FRESHER_30_SHARE_TWO_FRIENDS: 323,
    TASK_TYPE_FRESHER_30_ACCEPT_COUPON_BUY_WAIMAI: 324,
    TASK_TYPE_FRESHER_30_BUY_JD_FLASH_SALE: 325,
    TASK_TYPE_FRESHER_30_USE_BONUS_AMOUNT: 326,
    TASK_TYPE_FRESHER_30_DRAW_PHONE_RED_PACKET: 327,
    TASK_TYPE_FRESHER_30_FOR_ONE_CASH: 328,
    TASK_TYPE_RETURN_OPENING_FEE_RED_PACKET: 329,
    TASK_TYPE_NEW_USER_CLAIM_V2: 330,
    TASK_TYPE_CARVE_UP_MILLIONS_CASH_BONUS: 331,
    TASK_TYPE_COPY_ITEM_TITLE_AND_CLAIM_COUPON_AND_BUY: 348,
    TASK_TYPE_SEARCH_ITEM_AND_CLAIM_COUPON_AND_BUY: 349,
    TASK_TYPE_LIVE_COMMUNITY_FIRST_ORDER: 357,
    TASK_TYPE_LIVE_COMMUNITY_NORMAL_ORDER: 358,
    TASK_TYPE_LIVE_COMMUNITY_SHARE_ORDER: 359,
    TASK_TYPE_CARVE_UP_MILLIONS_CASH_BONUS_V2: 360,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_ACCUMULATED_CASH_L1: 361,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_ACCUMULATED_CASH_L2: 362,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_ACCUMULATED_CASH_L3: 363,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_USER_SHOW_SHARE_GUIDE: 364,
    TASK_TYPE_PULL_NEW_JD_INVITE_FRIEND_CASH_BONUS: 365,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_INVITE_REGISTER_L1: 366,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_INVITE_REGISTER_L2: 367,
    TASK_TYPE_PULL_NEW_FAMILY_GROUP_INVITE_REGISTER_L3: 368,
    TASK_TYPE_CARVE_UP_MILLIONS_CASH_BONUS_V3: 369,
    TASK_TYPE_FRESHER_30_BUY_JINGXI_CHANNEL_SALE: 370,
    TASK_TYPE_QTT_CPC: 371,
    TASK_TYPE_SAVE_MONEY_CARD_FREE_BUY: 372,
    TASK_TYPE_MIAO_COIN_DAY_DAY_EARN_ACTIVITY_FOR_QTT_AD: 373,
    TASK_TYPE_XIANWAN_PLAY_GAME_TO_EARN_MIAO_COIN: 374,
    TASK_TYPE_SAVE_MONEY_CARD_FREE_BUY_V2: 375,
    TASK_TYPE_WANGYI_YANXUAN_CPA_V2_REWARD: 376,
    TASK_TYPE_DAILY_JUMP_TO_XIANWAN: 377,
    TASK_TYPE_SAVE_MONEY_CARD_UNION_ELEME: 384,
    TASK_TYPE_LOTTERY_WATCH_VIDEO: 385,
    TASK_TYPE_LOTTERY_INVITER_NEW_USER: 386,
    TASK_TYPE_LOTTERY_TRY_AD: 387,
    TASK_TYPE_LOTTERY_JINGDONG_NEW_USER: 388,
    TASK_TYPE_LOTTERY_MIAO_COIN_EXCHANGE: 389,
    TASK_TYPE_LOTTERY_SAVE_MONEY_CARD: 390,
    TASK_TYPE_LOTTERY_TAKEOUT: 391,
    TASK_TYPE_LOTTERY_TAOBAO_SHOPPING: 392,
    TASK_TYPE_LOTTERY_TAOBAO_ACTIVITY_PAGE_SHOPPING: 393,
    TASK_TYPE_LOTTERY_ACCUMULATIVE_EARN_MIAO_COIN: 394,
    TASK_TYPE_MEMBERSHIP_RETURN_OPEN_FEE_BY_SIGN_IN: 395,
    TASK_TYPE_HOME_PAGE_REWARD: 396,
    TASK_TYPE_NEWBIE_WATCH_MOTIVATE_VIDEO_ONCE: 397,
    TASK_TYPE_FREE_BUY_ALLOWANCE_JING_DONG_NEWBIE: 398,
    TASK_TYPE_FREE_BUY_ALLOWANCE_MEITUAN_UNION_YOUXUAN: 399,
    TASK_TYPE_FREE_BUY_ALLOWANCE_TAKEOUT: 400,
    TASK_TYPE_CPC_FREE_BUY: 401,
    TASK_TYPE_CPC_LUCKY_BAG: 402,
    TASK_TYPE_FREE_BUY_ALLOWANCE_SIGN_IN: 403,
    TASK_TYPE_FREE_BUY_ALLOWANCE_SHOPPING_GUIDE: 404,
    TASK_TYPE_FREE_BUY_ALLOWANCE_VISITING_SECKILL: 405,
    TASK_TYPE_FREE_BUY_ALLOWANCE_MEITUAN: 406,
    TASK_TYPE_FREE_BUY_ALLOWANCE_ELEME: 407,
    TASK_TYPE_CPC_FLOATING_WINDOW: 408,
    TASK_TYPE_FREE_BUY_ALLOWANCE_WEIPINHUI_NEWBIE: 409,
    TASK_TYPE_FREE_BUY_ALLOWANCE_PINDUODUO_NEWBIE: 410,
    TASK_TYPE_FREE_BUY_ALLOWANCE_SIGN_IN_EXTRA_VIDEO_REWARD: 411,
    TASK_TYPE_GROUP_BUYING_3: 422,
    TASK_TYPE_GROUP_BUYING_4: 423,
    TASK_TYPE_CASHBACK_LEARN_TUTORIAL: 424,
    TASK_TYPE_CASHBACK_JUMP_TAOBAO_BUY: 425,
    TASK_TYPE_CASHBACK_JUMP_JINGDONG_BUY: 426,
    TASK_TYPE_CASHBACK_JUMP_PINDUODUO_BUY: 427,
    TASK_TYPE_CASHBACK_JUMP_WEIPINHUI_BUY: 428,
    TASK_TYPE_CASHBACK_TAKEOUT_ORDER: 429,
    TASK_TYPE_CASHBACK_THREE_DISCOUNT_ELECTRICITY_BILL: 430,
    TASK_TYPE_CASHBACK_THREE_DISCOUNT_PHONE_BILL: 431,
    TASK_TYPE_CASHBACK_LEARN_TUTORIAL_GAME: 432,
    TASK_TYPE_CASHBACK_LEARN_TUTORIAL_COPY_TAOBAO_TITLE: 433,
    TASK_TYPE_ELEME_GIFT_PACKAGE: 434,
};

export const TaskTypeDisplayName = {
    424 /* TASK_TYPE_CASHBACK_LEARN_TUTORIAL */: "学习新手省钱教程",
    425 /* TASK_TYPE_CASHBACK_JUMP_TAOBAO_BUY */: "跳转淘宝优惠购物",
    426 /* TASK_TYPE_CASHBACK_JUMP_JINGDONG_BUY */: "跳转京东优惠购物",
    427 /* TASK_TYPE_CASHBACK_JUMP_PINDUODUO_BUY */: "跳转拼多多优惠购物",
    428 /* TASK_TYPE_CASHBACK_JUMP_WEIPINHUI_BUY */: "跳转唯品会优惠购物",
    429 /* TASK_TYPE_CASHBACK_TAKEOUT_ORDER */: "外卖平台优惠点餐",
    430 /* TASK_TYPE_CASHBACK_THREE_DISCOUNT_ELECTRICITY_BILL */: "体验3折优惠缴电费",
    431 /* TASK_TYPE_CASHBACK_THREE_DISCOUNT_PHONE_BILL */: "体验3折优惠充话费",
    432 /* TASK_TYPE_CASHBACK_LEARN_TUTORIAL_GAME */: "答题现金红包",
    433 /* TASK_TYPE_CASHBACK_LEARN_TUTORIAL_COPY_TAOBAO_TITLE */: "淘宝复制标题现金红包",
    434 /* TASK_TYPE_ELEME_GIFT_PACKAGE */: "饿了么礼包",
};

export const TaskStatus = {
    TASK_STATUS_UNDEFINED: 0,
    TASK_STATUS_ACCEPTED: 1,
    TASK_STATUS_REWARD_GIVEN: 2,
    TASK_STATUS_INVALID: 3,
    TASK_STATUS_AVAILABLE: 4,
    TASK_STATUS_COMPLETED: 5,
};


export const ShareBonusType = {
    SHARE_BONUS_TYPE_UNDEFINED: 0,
    SHARE_BONUS_TYPE_FREE_BUY: 1,
    SHARE_BONUS_TYPE_PHONE_CHARGE: 3,
    SHARE_BONUS_TYPE_NORMAL: 4,
    SHARE_BONUS_TYPE_SUPER: 5,
    SHARE_BONUS_TYPE_REAL_ZERO_BUY: 9,
    SHARE_BONUS_TYPE_INVITE_PHONE_CHARGE: 11,
    SHARE_BONUS_TYPE_SEC_KILL_REFUND: 12,
    SHARE_BONUS_TYPE_WEEK_FREE_BUY: 13,
    SHARE_BONUS_TYPE_FIRST_FREE_BUY: 14,
    SHARE_BONUS_TYPE_DEPOSIT: 15,
    SHARE_BONUS_TYPE_1YUAN_BUY: 23,
    SHARE_BONUS_TYPE_MEMBERSHIP_ELEME: 27,
    SHARE_BONUS_TYPE_MEMBERSHIP_MEITUAN: 35,
    SHARE_BONUS_TYPE_MEMBERSHIP_QIANZHU_KFC: 36,
    SHARE_BONUS_TYPE_JINGDONG_PULL_NEW: 37,
    SHARE_BONUS_TYPE_KLOOK_TRAIN_TICKET: 38,
    SHARE_BONUS_TYPE_QIANZHU_MOVIE_TICKET: 39,
    SHARE_BONUS_TYPE_NOT_MEMBERSHIP_WAIMAI_FIRST_ORDER: 40,
    SHARE_BONUS_TYPE_NOT_MEMBERSHIP_TAKEOUT_FIRST_ORDER: 40,
    SHARE_BONUS_TYPE_HAIWEI_H5: 41,
};


export const EnlargeFlowTaskStatus = {
    ENLARGE_FLOW_TASK_STATUS_UNDEFINED: 0,
    ENLARGE_FLOW_TASK_STATUS_ONLINE: 1,
    ENLARGE_FLOW_TASK_STATUS_OFFLINE: 2,
};


export const TaskCategory = {
    TASK_CATEGORY_UNDEFINED: 0,
    TASK_CATEGORY_DAILY_TASK: 1,
    TASK_CATEGORY_LIFE_RIGHTS: 2,
};


export const Game = {
    GAME_UNDEFINED: 0,
    GAME_FARM: 1,
    GAME_MIND_MASTER: 2,
    GAME_EARN_BY_SLEEPING: 3,
    GAME_EARN_BY_WALKING: 4,
};


export const ExchangeCategory = {
    EXCHANGE_CATEGORY_UNDEFINED: 0,
    EXCHANGE_CATEGORY_1YUAN_BUY: 1,
    EXCHANGE_CATEGORY_CASH: 2,
};


export const Action = {
    ACTION_UNDEFINED: 0,
    ACTION_FINISH: 1,
    ACTION_ACCEPT: 2,
    ACTION_CLAIM: 3,
    ACTION_CREATE: 4,
    ACTION_INVALID: 5,
};


export const SearchTaskRedPacketStatus = {
    SEARCH_TASK_RED_PACKET_STATUS_UNDEFINED: 0,
    SEARCH_TASK_RED_PACKET_STATUS_UNCLAIMED: 1,
    SEARCH_TASK_RED_PACKET_STATUS_CLAIMED: 2,
};


export const SearchTaskConditionStatus = {
    SEARCH_TASK_CONDITION_STATUS_UNDEFINED: 0,
    SEARCH_TASK_CONDITION_STATUS_UNDONE: 1,
    SEARCH_TASK_CONDITION_STATUS_DONE: 2,
};


export const SearchTaskEntryFrom = {
    SEARCH_TASK_ENTRY_FROM_UNDEFINED: 0,
    SEARCH_TASK_ENTRY_FROM_HOME_SEARCH_BOX: 1,
    SEARCH_TASK_ENTRY_FROM_SEARCH_PAGE: 2,
};


export const QTTCPCRedPacketStatus = {
    QTTCPC_RED_PACKET_STATUS_UNDEFINED: 0,
    QTTCPC_RED_PACKET_STATUS_LOCKED: 1,
    QTTCPC_RED_PACKET_STATUS_UNLOCKED: 2,
    QTTCPC_RED_PACKET_STATUS_WITHDRAWN: 3,
};


export const SaveMoneyCardTaskCategory = {
    SAVE_MONEY_CARD_TASK_CATEGORY_UNDEFINED: 0,
    SAVE_MONEY_CARD_TASK_CATEGORY_SHOPPING: 1,
    SAVE_MONEY_CARD_TASK_CATEGORY_TAKEOUT: 2,
};


export const GroupBuyingStatus = {
    GROUP_BUYING_STATUS_UNDEFINED: 0,
    GROUP_BUYING_STATUS_ITEM_INVALID: 1,
    GROUP_BUYING_STATUS_PROCESSING: 2,
    GROUP_BUYING_STATUS_SUCCESS: 3,
    GROUP_BUYING_STATUS_FAILED: 4,
};


